import { render } from "./RegisterVendor.vue?vue&type=template&id=180514b6"
import script from "./RegisterVendor.vue?vue&type=script&lang=js"
export * from "./RegisterVendor.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__